{
  "pt": {
    "marketplace_partner": {
      "contact_me": {
        "success": "Entraremos em contacto consigo brevemente.",
        "failure": "Ocorreu um erro inesperado.",
        "button": "Contacte-me!"
      }
    }
  }
}
